<template>
  <v-container>
    <v-card
      v-if="steporder.model?.[0]"
      color="#efefef"
      class="ma-0 mb-5"
    >
      <v-row>
        <div class="text-h3 text-weigth-light ma-6">
          Montatura
        </div>
      </v-row>

      <v-card-text>
        {{ steporder.model?.[0]?.linea }} <b> {{ steporder.model?.[0]?.modello }} </b><br>
        <p class="ma-2">
          <v-btn
            text
            x-small
            @click="$set(steporder,'model',[])"
          >
            <v-icon color="primary">
              mdi-circle-edit-outline
            </v-icon>
          </v-btn>  {{ steporder.model?.[0]?.descrizione }}
        </p>
        <v-row class="mt-3 text-body-1">
          <v-col
            cols="12"
            md="auto"
            class="px-8"
          >
            <table>
              <tr><td>Marca:</td><td> {{ steporder.model?.[0]?.marca }}</td></tr>
              <tr>
                <td>Linea:</td>
                <td> {{ steporder.model?.[0]?.linea }}</td>
              </tr>
              <tr>
                <td>Mod.:</td>
                <td> {{ steporder.model?.[0]?.modello }}</td>
              </tr>
              <tr>
                <td>Colore:</td>
                <td> {{ steporder.model?.[0]?.colore }}</td>
              </tr>
              <tr>
                <td>Calibro:</td>
                <td> {{ steporder.model?.[0]?.calibro }}</td>
              </tr>
              <tr>
                <td>Ponte:</td>
                <td> {{ steporder.model?.[0]?.ponte }}</td>
              </tr>
            </table>
          </v-col>

          <v-col
            cols="12"
            md="auto"
            class="px-8"
          >
            <table>
              <tr>
                <td>Asta:</td>
                <td> {{ steporder.model?.[0]?.asta }}</td>
              </tr>
              <tr>
                <td>Tipo_lente:</td>
                <td> {{ steporder.model?.[0]?.tipo_lente }}</td>
              </tr>
              <tr>
                <td>Materiale:</td>
                <td> {{ steporder.model?.[0]?.materiale }}</td>
              </tr>
              <tr>
                <td>Utente:</td>
                <td> {{ steporder.model?.[0]?.utente }}</td>
              </tr>
              <tr>
                <td>Cat. filtro:</td>
                <td>{{ steporder.model?.[0]?.cat_filtro }}</td>
              </tr>
              <tr>
                <td>Lente polarizzata:</td>
                <td> {{ steporder.model?.[0]?.lente_polarizzata }}</td>
              </tr>
            </table>
          </v-col>
        </v-row>

        <!-- {{ steporder.model?.[0] }} -->
      </v-card-text>
    </v-card>
    <v-card
      v-else
      color="#efefef"
      class="ma-0 mb-5"
    >
      <!-- <v-row
        justify="center"
        class="pa-5 "
      >
        {{ steporder }}
      </v-row> -->
      <v-row>
        <div class="text-h3 text-weigth-light ma-6">
          Montatura
        </div>
      </v-row>

      <v-form
        ref="form"
        v-model="validForm"
      >
        <v-row class="pa-5 ">
          <!-- LINEA -->
          <v-col
            cols="12"
            md="4"
          >
            <v-autocomplete
              v-model="grvselection.linea"
              outlined
              :items="items_linea"
              :rules="[rules.required]"
              color="blue-grey lighten-2"
              label="Linea"
              clearable
              class="my-0 py-0 text-body-1"
              height="55px"
              @click:clear="grvselection={};"
              @change="cambiolinea()"
            />
          </v-col>
          <!-- UTENTE -->
          <v-col
            cols="12"
            md="4"
          >
            <!-- <v-autocomplete
              v-model="grvselection.utente"
              :disabled="!grvselection.linea"
              outlined
              :items="items_utente"
              :rules="grvselection.linea?[rules.required]:[]"
              color="blue-grey lighten-2"
              label="Utente"
              clearable
              class="my-0 py-0 text-body-1"
              height="55px"
              @change="$set(steporder,'model',[])"
            /> -->
            <v-btn
              v-for="(itm,idx) in items_utente"
              :key="idx"
              :color="itm==grvselection.utente?'primary':'blue-grey lighten-2'"
              @click="$set(grvselection,'utente',itm); $set(steporder,'model',[]); items_tipolente.length===1?$set(grvselection,'tipo_lente',items_tipolente[0]):'';"
            >
              {{ itm }}
            </v-btn>
          </v-col>
          <!-- TIPO LENTE -->
          <v-col
            cols="12"
            md="4"
          >
            <!-- <v-autocomplete
              v-model="grvselection.tipo_lente"
              :disabled="!grvselection.utente"
              outlined
              :items="items_tipolente"
              :rules="grvselection.utente?[rules.required]:[]"
              color="blue-grey lighten-2"
              label="Tipo Lente"
              clearable
              class="my-0 py-0 text-body-1"
              height="55px"
              @change="$set(steporder,'model',[])"
            /> -->
            <v-btn
              v-for="(itm,idx) in items_tipolente"
              :key="idx"
              :color="itm==grvselection.tipo_lente?'primary':'blue-grey lighten-2'"
              @click="$set(grvselection,'tipo_lente',itm); $set(steporder,'model',[])"
            >
              {{ itm }}
            </v-btn>
          </v-col>
          <!-- DISPONIBILITA
          <v-col
            cols="12"
            md="6"
          >
            <v-autocomplete
              v-model="grvselection.disponibilita"
              :disabled="!grvselection.tipo_lente"
              outlined
              :items="[{ value: true, text: 'Qualsiasi' },{ value: '1', text: 'Immediata' },{ value: '0', text: 'In Approvigionamento' }]"
              :rules="grvselection.tipo_lente?[rules.required]:[]"
              color="blue-grey lighten-2"
              label="Disponibilità"
              clearable
              class="my-0 py-0 text-body-1"
              height="55px"
              @change="$set(steporder,'model',[])"
            />
          </v-col>
        </v-row>-->
          <v-row>
            <v-col
              cols="12"
            >
              <template v-for="(filter, key) in activeFilters">
                <v-chip
                  v-if="filter && filter!==''"
                  :key="key"
                  class="ma-1"
                  close
                  @click:close="tempFilters[key]=null,activeFilters[key]=null"
                >
                  {{ key }}: {{ filter }}
                </v-chip>
              </template>
              <v-data-table
                v-model="steporder.model"
                height="400px"
                :headers="headers"
                :items="filteredItems"
                item-key="sku"
                fixed-header
                mobile-breakpoint="0"
                disable-pagination
                hide-default-footer
                dense
                show-select
                single-select
              >
                <!-- Slot Dinamico per ogni Header -->
                <template
                  v-for="header in headers"
                  v-slot:[`header.${header.value}`]
                >
                  <div
                    v-if="header.filtro"
                    :key="header.value"
                    class="d-inline-flex align-center"
                  >
                    {{ header.text }}

                    <v-menu
                      v-model="menuActive[header.value]"
                      :close-on-content-click="false"
                      offset-y
                      color="blue-grey lighten-2"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          dark
                          v-bind="attrs"
                          small
                          v-on="on"
                        >
                          <v-icon :color="activeFilters[header.value] ? 'primary' : '#ccc'">
                            mdi-filter-plus
                          </v-icon>
                        </v-btn>
                      </template>

                      <v-card
                        class="pa-2 ma-0"
                        width="200"
                      >
                        <v-text-field
                          class="ma-2"
                          :value="tempFilters[header.value]"
                          :label="`Filtra ${header.text}`"
                          hide-details
                          dense
                          clearable
                          @input="val => onFilterInput(header.value, val)"
                          @click:clear="onFilterInput(header.value, '')"
                        />
                        <v-btn
                          x-small
                          color="primary"
                          @click="menuActive[header.value] = false"
                        >
                          close
                        </v-btn>
                      </v-card>
                    </v-menu>
                  </div>
                  <div
                    v-else
                    :key="header.value"
                    class="d-inline-flex align-center"
                  >
                    {{ header.text }}
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-row>
      </v-form>
    </v-card>
    <v-btn
      color="primary"
      :disabled="!validForm && steporder.model?.length==0 "
      @click="nextStep"
    >
      Avanti
    </v-btn>
    <v-btn
      text
      @click="prevStep"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import grvengine from '@/plugins/grvengine'
  import debounce from 'lodash/debounce'

  export default {
    name: 'Step3',
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        steporder: {},
        grvselection: {},
        validForm: true,
        lista_grvmodels: [],

        headers: [
          { text: 'Modello', value: 'modello', filtro: true },
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Calibro', value: 'calibro', filtro: true },
          { text: 'Ponte', value: 'ponte', filtro: true },
          { text: 'Asta', value: 'asta', filtro: true },
          { text: 'Colore', value: 'colore' },
          { text: 'Filtro', value: 'cat_filtro' },
          { text: 'Polarizzata', value: 'lente_polarizzata' },
          { text: 'Materiale', value: 'materiale', filtro: true },
          { text: 'Disponibilita', value: 'magazzino' },

        ],
        // Valori "temporanei" legati agli input (aggiornamento immediato)
        tempFilters: { modello: '', calibro: '', ponte: '', asta: '', materiale: '' },
        // Valori "reali" usati per il calcolo del filtro (aggiornamento debounced)
        activeFilters: { modello: '', calibro: '', ponte: '', asta: '', materiale: '' },
        menuActive: {},
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'clidata']),
      rules () {
        return {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
        }
      },
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      dataitems () {
        return []
      },
      items_linea () {
        return [...new Set(this.lista_grvmodels.map(item => item.linea?.trim().toUpperCase()))].sort()
      },
      items_utente () {
        return [...new Set(this.lista_grvmodels.filter(item =>
          item.linea?.trim().toUpperCase() === this.grvselection.linea,
        ).map(item => item.utente === '' ? 'UNISEX' : item.utente?.trim().toUpperCase()))].sort()
      },
      items_tipolente () {
        return [...new Set(this.lista_grvmodels.filter(item =>
          item.linea?.trim().toUpperCase() === this.grvselection.linea &&
          item.utente?.trim().toUpperCase() === this.grvselection.utente,
        ).map(item => item.tipo_lente === '' ? 'VISTA' : item.tipo_lente?.trim().toUpperCase()))].sort()
      },
      items_grvmodels () {
        return this.lista_grvmodels.filter(item => {
          return (item.linea?.trim().toUpperCase() === this.grvselection.linea &&
          item.utente?.trim().toUpperCase() === this.grvselection.utente &&
          item.tipo_lente?.trim().toUpperCase() === this.grvselection.tipo_lente &&
          (this.grvselection.disponibilita === true || +item.magazzino === +this.grvselection.disponibilita)
          )
        },

        )
      },
      filteredItems () {
        return this.items_grvmodels.filter(item => {
          return Object.keys(this.activeFilters).every(key => {
            const filterValue = this.activeFilters[key]
            if (!filterValue) return true
            return String(item[key]).toLowerCase().includes(filterValue.toLowerCase())
          })
        })
      },
    },
    watch: {
      step (newVal, oldVal) {
        this.initData(newVal)
      },
    },
    created () {
      // this.$store.watch(
      //   (state) => state.order,
      //   (newValue, oldValue) => {
      //     console.log('Order changed from', oldValue, 'to', newValue)
      //     if (newValue) {
      //       this.steporder = Object.assign({}, newValue)
      //     }
      //   },
      //   {
      //     deep: true, // Optional: Use this if you need to watch nested properties
      //   },
      // )
    },
    mounted () {
      this.initData(this.step)
      // window.addEventListener('beforeunload', this.preventNav)
      // this.steporder = Object.assign({}, this.order)
      // this.loadCompo()
    },
    beforeDestroy () {
      // window.removeEventListener('beforeunload', this.preventNav)
      // console.log(' step3 beforedestroyed')
    },
    methods: {
      // 1. Aggiorna immediatamente l'interfaccia (tempFilters)
      // 2. Chiama la funzione debounced per aggiornare il filtro reale
      onFilterInput (column, value) {
        this.$set(this.tempFilters, column, value)
        this.debounceSearch(column, value)
      },

      // Funzione debounced creata una sola volta
      debounceSearch: debounce(function (column, value) {
        this.$set(this.activeFilters, column, value)
      }, 400), // Attende 400ms dopo l'ultimo tasto premuto
      initData (stp) {
        if (this.$options.name === `Step${stp}`) {
          console.log('load', this.$options.name)
          this.steporder = Object.assign({}, this.order)
          if (this.lista_grvmodels.length === 0) {
            this.loadListaGrvmodels()
          }
        }
      },
      nextStep () {
        if (!this.validForm || !this.steporder.model?.[0]) { return }
        if (this.step > this.steporder.step) { this.steporder.step = this.step }
        console.log('steporder', this.steporder)
        this.$store.commit('setOrder', this.steporder)
        this.$emit('nextStep', this.step + 1)
      },
      prevStep () {
        // if (this.$store.state.order.monsmo === 'S') {
        //   this.$emit('prevStep', this.step - 1)
        //   return
        // }
        this.$emit('prevStep', this.step)
      },
      loadListaGrvmodels () {
        this.loading = true
        grvengine.get_listaGrvmodels()
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })

              return
            }
            this.lista_grvmodels = result.data
          })
          .catch((errore) => {
            console.log(errore)
          }).finally(() => { this.loading = false })
      },
      preventNav (event) {
        if (this.isEditing) {
          console.log('isEditing', this.isEditing)
          event.preventDefault()
          event.returnValue = '' // Required for Chrome
        }
      },
      cambiolinea () {
        this.$set(this.steporder, 'model', [])
        this.$set(this.steporder, 'accessory', [])
        this.grvselection.disponibilita = true
        this.$nextTick(() => {
          if (this.items_utente.length === 1) {
            this.$set(this.grvselection, 'utente', this.items_utente[0])
          }
        })
        this.$nextTick(() => {
          if (this.items_tipolente.length === 1) {
            this.$set(this.grvselection, 'tipo_lente', this.items_tipolente[0])
          }
        })
      },
    },
  }
</script>
